import {INPUT_TYPES} from 'generators/input/GeneratedInput';
import * as yup from 'yup';
import {ERROR_MESSAGE, VALIDATORS_TYPE} from 'generators/validation/constants';

export const EMAIL_FIELDS = [
    {
        name: 'email',
        label: 'Email',
        type: 'email',
        inputType: INPUT_TYPES.TEXT,
        margin: 'normal',
        validations: yup.string().email('Неверный формат email').required('Поле должно быть заполнено'),
        autoComplete: 'email',
        autoFocus: true
    }
];

export const PASSWORD_FIELDS = [
    {
        name: 'password',
        type: 'password',
        label: 'Пароль',
        inputType: INPUT_TYPES.TEXT,
        margin: 'normal',
        validations: yup.string().required(ERROR_MESSAGE[VALIDATORS_TYPE.REQUIRED])
    },
    {
        name: 'confirmPassword',
        type: 'password',
        label: 'Подтверждение пароля',
        inputType: INPUT_TYPES.TEXT,
        margin: 'normal',
        validations: yup.string().oneOf([yup.ref('password'), null], 'Пароли не совпадают').required(ERROR_MESSAGE[VALIDATORS_TYPE.REQUIRED])
    }
];